<template>
  <v-dialog v-model="dialogShow" persistent max-width="750px" :retain-focus="false" :scrollable="true">
    <OverlayLoading :loading="loadingSaveEdit" class="loading-waitingSaveEdit"></OverlayLoading>
      <v-card tile class="pt-4 pl-10 pr-6 pb-4">
        <div class="">
          <span class="black--text font-weight-bold mr-5">สรุปรายการแก้ไขโครงสร้างบริษัท</span>
          <v-btn absolute right top icon x-small @click="closeThisDialog" :disabled="snackbar"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-btn v-if="!sendAllReq" @click="pressSendAllReq()" width="140" absolute right top small color="#f5f5f5" elevation="0" class="icon-eye-color" style="top: 62px; right: 40px; z-index: 10;" :disabled="isZero">ส่งคำขอทั้งหมด</v-btn>
        <v-btn v-else @click="pressCancelAllReq()" width="140" absolute right top small outlined elevation="0" class="grey--text" style="top: 62px; right: 40px; z-index: 10;">ยกเลิกคำขอทั้งหมด</v-btn>
        <v-tabs
          left
          class="mt-2"
          style="min-height: 65vh;"
        >
          <v-tabs-slider color="#2BA197"></v-tabs-slider>
          <v-tab style="font-size: 16px;" class="icon-eye-color">
            {{tabName[0]}}
            <v-chip
              small
              pill
              :color="'#f5f5f5'"
              class="icon-eye-color ml-1"
            >
              {{itemReq.changeLeaderList? itemReq.changeLeaderList.length:0 || 0}}
            </v-chip>
          </v-tab>
          <v-tab style="font-size: 16px;" class="icon-eye-color">
            {{tabName[1]}}
            <v-chip
              small
              pill
              :color="'#f5f5f5'"
              class="icon-eye-color ml-1"
            >
              {{itemReq.changeDetialList? itemReq.changeDetialList.length:0 || 0}}
            </v-chip>
          </v-tab>
          <v-tab-item class="mt-4 pr-2" style="overflow-y: auto; overflow-x: hidden; height: 65vh;" transition="fade-transition" reverse-transition="fade-transition">
            <v-row v-if="itemReq.changeLeaderList.length === 0" class="my-15" justify=center>
              <v-col cols="8" class="text-center mt-6">
                <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="" style="font-weight: normal;">ไม่มีข้อมูลการแก้ไข</span>
              </v-col>
            </v-row>
            <v-card
              class="mt-2 mb-4 pa-1"
              outlined
              v-for="item in itemReq.changeLeaderList"
              :key="item.id"
            >
            <div class="ml-6 mr-6" style="margin-bottom: -6px;">
              <v-row class="mt-1 mb-1">
                <span>{{item.orgChartName}}</span>
                <v-btn v-if="!sendReqDoneList.includes(item.id+'.leader')" absolute right small width="70" color="#f5f5f5" elevation="0" class="icon-eye-color" style="top: 5px;" @click="pressSendReqChangeLeader(item)">ส่งคำขอ</v-btn>
                <v-btn v-else absolute right small width="70" outlined color="grey" elevation="0" class="grey--text" style="top: 5px;" @click="cancelpressSendReqChangeLeader(item)">ยกเลิก</v-btn>
              </v-row>
               <v-row>
                <v-divider/>
              </v-row>
              <v-row v-if="item.before.leaderId && item.action=='edit'">
                <v-col cols="6">
                  <v-row class="mt-1 mb-1">
                  <v-chip
                    small
                    :color="'#FBE5E4'"
                    :text-color="'#D1392B'"
                  >
                    <span >ลบผู้บังคับบัญชา</span>
                  </v-chip>
                  </v-row>
                  <v-row class="mt-1 mb-1">
                    <span class="ra-head-text-gray">{{item.before.name}}</span>
                  </v-row>
                  <v-row class="mt-1">
                    <span class="ra-head-text-gray">{{item.before.leaderPosition}}</span>
                  </v-row>
                </v-col>
                  <div style="position: absolute; left: 50%; bottom: 10px; top: 10px; margin-top: 40px;">
                   <v-divider vertical ></v-divider>
                  </div>
                <v-col cols="6">
                  <v-row class="ml-1 mt-1 mb-1">
                  <v-chip
                    small
                    :color="'#ECF8EA'"
                    :text-color="'#58A144'"
                  >
                    <span>เพิ่มผู้บังคับบัญชา</span>
                  </v-chip>
                  </v-row>
                  <v-row class="ml-1  mt-1 mb-1">
                    <span class="ra-head-text-gray">{{item.after.name}}</span>
                  </v-row>
                  <v-row class="ml-1  mt-1">
                    <span class="ra-head-text-gray">{{item.after.leaderPosition}}</span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-else-if="!item.before.leaderId && item.action=='edit'">
                <v-col cols="12">
                  <v-row class="mt-1 mb-1">
                  <v-chip
                    small
                    :color="'#ECF8EA'"
                    :text-color="'#58A144'"
                  >
                    <span>เพิ่มผู้บังคับบัญชา</span>
                  </v-chip>
                  </v-row>
                  <v-row class="mt-1 mb-1">
                    <span class="ra-head-text-gray">{{item.after.name}}</span>
                  </v-row>
                  <v-row class="mt-1">
                    <span class="ra-head-text-gray">{{item.after.leaderPosition}}</span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="6">
                  <v-row class="mt-1 mb-1">
                  <v-chip
                    small
                    :color="'#FBE5E4'"
                    :text-color="'#D1392B'"
                  >
                    <span >ลบผู้บังคับบัญชา</span>
                  </v-chip>
                  </v-row>
                  <v-row class="mt-1 mb-1">
                    <span class="ra-head-text-gray">{{item.before.name}}</span>
                  </v-row>
                  <v-row class="mt-1">
                    <span class="ra-head-text-gray">{{item.before.leaderPosition}}</span>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            </v-card>
          </v-tab-item>
          <!-- 2nd Tab -->
          <v-tab-item class="mt-4 pr-2" style="overflow-y: auto; overflow-x: hidden; height: 65vh;" transition="fade-transition" reverse-transition="fade-transition">
            <v-row v-if="itemReq.changeDetialList.length === 0" class="my-15" justify=center>
              <v-col cols="8" class="text-center mt-6">
                <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="" style="font-weight: normal;">ไม่มีข้อมูลการแก้ไข</span>
              </v-col>
            </v-row>
            <v-card
              class="mt-2 mb-4 pa-1"
              outlined
              v-for="item in itemReq.changeDetialList"
              :key="item.id"
            >
            <div class="ml-6 mr-6" style="margin-bottom: -6px;" v-if="item.action=='edit'" :isExpand="false">
              <!-- Current Node -->
              <v-row class="mt-2 mb-1">
                <v-chip
                  small
                  :color="'#EEEEEE'"
                  :text-color="'#999999'">
                  <span >สายบังคับบัญชาต้นทาง</span>
                </v-chip>
              </v-row>
              <v-row class="mt-1 mb-1">
                <v-col cols="11" class="text-left" style="margin: -10px;">
                  <span style="margin-left: 0px;">{{item.before.pid? item.before.orgChartName:'บริษัท ' + company}}</span>
                </v-col>
                <v-col cols="1" class="text-right" style="margin: -10px;" v-show="(item.before.leaderIdPid || item.after.leaderIdPid) || (item.before.leaderIdPicked!==null && item.before.leaderIdPicked!==undefined) || (item.after.leaderIdPicked!==null && item.after.leaderIdPicked!==undefined)">
                  <v-btn v-if="!sendReqDoneList.includes(item.id+'.orgchart')" small width="70" color="#EFF4FD" elevation="0" class="icon-eye-color" style="margin-right: -12px;" @click="pressSendReqChangeOrgchart(item, item.before)">ส่งคำขอ</v-btn>
                  <v-btn v-else  small width="70" outlined color="grey" elevation="0" class="grey--text"  style="margin-right: -12px;" @click="cancelpressSendReqChangeOrgchart(item, item.before)">ยกเลิก</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-divider/>
              </v-row>
              <!-- Current Node Has Approver -->
              <v-row v-if="item.before.leaderIdPid!==''">
                <v-col cols="12">
                  <v-row class="mt-1 mb-1" v-if="item.before.leaderPidName">
                    <span class="ra-head-text-gray">{{item.before.leaderPidName}}</span>
                  </v-row>
                  <v-row class="mt-1" v-if="item.before.leaderPidName">
                    <span class="ra-head-text-gray">{{item.before.leaderPosition}}</span>
                  </v-row>
                  <v-row class="mt-1" v-if="item.before.moreDetail">
                    <a
                      class="mr-0"
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      style="text-decoration-line: underline; font-size: 14px;"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'ดูข้อมูลเพิ่มเติม':'ดูข้อมูลเพิ่มเติม'}}</a>
                    <v-icon
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      dark
                      color="primary"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
                  </v-row>
                  <v-row class="mt-1" v-if="listExpand.includes(item.id+'.orgchart.'+item.before.pid)">
                    <v-card
                      class="user-data-panel"
                      style="margin-top: 0px; width: 100vw;"
                      outlined
                    >
                      <v-treeview
                        open-all
                        dense
                        :items="item.before.moreDetail? item.before.moreDetail:[]"
                      ></v-treeview>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Current Node NO Approver -->
              <v-row v-else>
                 <v-col cols="12">
                  <v-row class="mt-1 mb-1">
                    <span class="ra-head-text-gray">ผู้อนุมัติ</span>
                  </v-row>
                  <v-row class="mt-1">
                    <v-col cols="7" style="margin: -10px;">
                      <v-autocomplete
                        v-model="item.before.leaderIdPicked"
                        :items="itemApprovers"
                        item-text="dataShow"
                        item-value="employee_id"
                        outlined
                        placeholder="ค้นหาจากรหัสพนักงานหรือ ชื่อ - นามสกุล"
                        no-data-text="ไม่พบข้อมูล"
                        class="mt-1"
                        dense
                        :background-color="'white'"
                        clearable
                        :disabled="sendReqDoneList.includes(item.id+'.orgchart')"
                        @keyup="getSelectLeader($event.target.value)"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="mt-1" v-if="item.before.moreDetail">
                    <a
                      class="mr-0"
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      style="text-decoration-line: underline; font-size: 14px;"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'ดูข้อมูลเพิ่มเติม':'ดูข้อมูลเพิ่มเติม'}}</a>
                    <v-icon
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      dark
                      color="primary"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
                  </v-row>
                  <v-row class="mt-1" v-if="listExpand.includes(item.id+'.orgchart.'+item.before.pid)">
                    <v-card
                      class="user-data-panel"
                      style="margin-top: 0px; width: 100vw;"
                      outlined
                    >
                      <v-treeview
                        open-all
                        dense
                        :items="item.before.moreDetail? item.before.moreDetail:[]"
                      ></v-treeview>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
              <!-- target node -->
              <v-row class="mt-1 mb-1">
                <v-chip
                  small
                  :color="'#ECF8EA'"
                  :text-color="'#58A144'"
                >
                  <span>สายบังคับบัญชาปลายทาง</span>
                </v-chip>
              </v-row>
              <v-row class="mt-1 mb-1">
                <v-col cols="11" class="text-left" style="margin: -10px;">
                  <span style="margin-left: 0px;">{{item.after.pid? item.after.orgChartName:'บริษัท ' + company}}</span>
                </v-col>
                <!-- <v-col cols="1" class="text-right" style="margin: -10px;" v-show="(item.before.leaderIdPid || item.after.leaderIdPid) || (item.before.leaderIdPicked!==null && item.before.leaderIdPicked!==undefined) || (item.after.leaderIdPicked!==null && item.after.leaderIdPicked!==undefined)">
                  <v-btn v-if="!sendReqDoneList.includes(item.id+'.orgchart.'+item.after.pid)" small width="70" color="#EFF4FD" elevation="0" class="blue--text" style="margin-right: -12px;" @click="pressSendReqChangeOrgchart(item, item.after)">ส่งคำขอ</v-btn>
                  <v-btn v-else  small width="70" outlined color="grey" elevation="0" class="grey--text"  style="margin-right: -12px;" @click="cancelpressSendReqChangeOrgchart(item, item.after)">ยกเลิก</v-btn>
                </v-col> -->
              </v-row>
              <v-row>
                <v-divider/>
              </v-row>
              <!-- target Node Has Approver -->
              <v-row v-if="item.after.leaderIdPid!==''">
                <v-col cols="12">
                  <v-row class="mt-1 mb-1" v-if="item.after.leaderPidName">
                    <span class="ra-head-text-gray">{{item.after.leaderPidName}}</span>
                  </v-row>
                  <v-row class="mt-1" v-if="item.after.leaderPidName">
                    <span class="ra-head-text-gray">{{item.after.leaderPosition}}</span>
                  </v-row>
                  <v-row class="mt-1" v-if="item.after.moreDetail">
                    <a
                      class="mr-0"
                      @click="listExpand.includes(item.id+'.orgchart.'+item.after.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.after.pid), 1):listExpand.push(item.id+'.orgchart.'+item.after.pid)"
                      style="text-decoration-line: underline; font-size: 14px;"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.after.pid)? 'ดูข้อมูลเพิ่มเติม':'ดูข้อมูลเพิ่มเติม'}}</a>
                    <v-icon
                      @click="listExpand.includes(item.id+'.orgchart.'+item.after.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.after.pid), 1):listExpand.push(item.id+'.orgchart.'+item.after.pid)"
                      dark
                      color="primary"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.after.pid)? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
                  </v-row>
                  <v-row class="mt-1" v-if="listExpand.includes(item.id+'.orgchart.'+item.after.pid)">
                    <v-card
                      class="user-data-panel"
                      style="margin-top: 0px; width: 100vw;"
                      outlined
                    >
                      <v-treeview
                        open-all
                        dense
                        :items="item.after.moreDetail? item.after.moreDetail:[]"
                      ></v-treeview>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
              <!-- target Node NO Approver -->
              <v-row v-else>
                 <v-col cols="12">
                  <v-row class="mt-1 mb-1">
                    <span class="ra-head-text-gray">ผู้อนุมัติ</span>
                  </v-row>
                  <v-row class="mt-1">
                    <v-col cols="7" style="margin: -10px;">
                      <v-autocomplete
                        v-model="item.after.leaderIdPicked"
                        :items="itemApprovers"
                        item-text="dataShow"
                        item-value="employee_id"
                        outlined
                        placeholder="ค้นหาจากรหัสพนักงานหรือ ชื่อ - นามสกุล"
                        no-data-text="ไม่พบข้อมูล"
                        class="mt-1"
                        dense
                        :background-color="'white'"
                        clearable
                        :disabled="sendReqDoneList.includes(item.id+'.orgchart')"
                        @keyup="getSelectLeader($event.target.value)"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="mt-1" v-if="item.after.moreDetail">
                    <a
                      class="mr-0"
                      @click="listExpand.includes(item.id+'.orgchart.'+item.after.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.after.pid), 1):listExpand.push(item.id+'.orgchart.'+item.after.pid)"
                      style="text-decoration-line: underline; font-size: 14px;"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.after.pid)? 'ดูข้อมูลเพิ่มเติม':'ดูข้อมูลเพิ่มเติม'}}</a>
                    <v-icon
                      @click="listExpand.includes(item.id+'.orgchart.'+item.after.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.after.pid), 1):listExpand.push(item.id+'.orgchart.'+item.after.pid)"
                      dark
                      color="primary"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.after.pid)? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
                  </v-row>
                  <v-row class="mt-1" v-if="listExpand.includes(item.id+'.orgchart.'+item.after.pid)">
                    <v-card
                      class="user-data-panel"
                      style="margin-top: 0px; width: 100vw;"
                      outlined
                    >
                      <v-treeview
                        open-all
                        dense
                        :items="item.after.moreDetail? item.after.moreDetail:[]"
                      ></v-treeview>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div class="ml-6 mr-6" style="margin-bottom: -6px;" v-else :isExpand="false">
              <v-row class="mt-2 mb-1">
                <v-chip
                  small
                  :color="'#FBE5E4'"
                  :text-color="'#D1392B'">
                  <span >ลบสายบังคับบัญชา</span>
                </v-chip>
              </v-row>
              <v-row class="mt-1 mb-1">
                <v-col cols="11" class="text-left" style="margin: -10px;">
                  <span style="margin-left: 0px;">{{item.before.pid? item.before.orgChartName:'บริษัท ' + company}}</span>
                </v-col>
                <v-col cols="1" class="text-right" style="margin: -10px;" v-show="(item.before.leaderIdPid || item.after.leaderIdPid) || (item.before.leaderIdPicked!==null && item.before.leaderIdPicked!==undefined) || (item.after.leaderIdPicked!==null && item.after.leaderIdPicked!==undefined)">
                  <v-btn v-if="!sendReqDoneList.includes(item.id+'.orgchart')" small width="70" color="#EFF4FD" elevation="0" class="icon-eye-color" style="margin-right: -12px;" @click="pressSendReqChangeOrgchart(item, item.before)">ส่งคำขอ</v-btn>
                  <v-btn v-else  small width="70" outlined color="grey" elevation="0" class="grey--text"  style="margin-right: -12px;" @click="cancelpressSendReqChangeOrgchart(item, item.before)">ยกเลิก</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-divider/>
              </v-row>
              <!-- Current Node Has Approver -->
              <v-row v-if="item.before.leaderIdPid!==''">
                <v-col cols="12">
                  <v-row class="mt-1 mb-1" v-if="item.before.leaderPidName">
                    <span class="ra-head-text-gray">{{item.before.leaderPidName}}</span>
                  </v-row>
                  <v-row class="mt-1" v-if="item.before.leaderPidName">
                    <span class="ra-head-text-gray">{{item.before.leaderPosition}}</span>
                  </v-row>
                  <v-row class="mt-1" v-if="item.before.moreDetail">
                    <a
                      class="mr-0"
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      style="text-decoration-line: underline; font-size: 14px;"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'ดูข้อมูลเพิ่มเติม':'ดูข้อมูลเพิ่มเติม'}}</a>
                    <v-icon
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      dark
                      color="primary"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
                  </v-row>
                  <v-row class="mt-1" v-if="listExpand.includes(item.id+'.orgchart.'+item.before.pid)">
                    <v-card
                      class="user-data-panel"
                      style="margin-top: 0px; width: 100vw;"
                      outlined
                    >
                      <v-treeview
                        open-all
                        dense
                        :items="item.before.moreDetail? item.before.moreDetail:[]"
                      ></v-treeview>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Current Node NO Approver -->
              <v-row v-else>
                 <v-col cols="12">
                  <v-row class="mt-1 mb-1">
                    <span class="ra-head-text-gray">ผู้อนุมัติ</span>
                  </v-row>
                  <v-row class="mt-1">
                    <v-col cols="7" style="margin: -10px;">
                      <v-autocomplete
                        v-model="item.before.leaderIdPicked"
                        :items="itemApprovers"
                        item-text="dataShow"
                        item-value="employee_id"
                        outlined
                        placeholder="ค้นหาจากรหัสพนักงานหรือ ชื่อ - นามสกุล"
                        no-data-text="ไม่พบข้อมูล"
                        class="mt-1"
                        dense
                        :background-color="'white'"
                        clearable
                        :disabled="sendReqDoneList.includes(item.id+'.orgchart')"
                        @keyup="getSelectLeader($event.target.value)"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="mt-1" v-if="item.before.moreDetail">
                    <a
                      class="mr-0"
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      style="text-decoration-line: underline; font-size: 14px;"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'ดูข้อมูลเพิ่มเติม':'ดูข้อมูลเพิ่มเติม'}}</a>
                    <v-icon
                      @click="listExpand.includes(item.id+'.orgchart.'+item.before.pid)? listExpand.splice(listExpand.indexOf(item.id+'.orgchart.'+item.before.pid), 1):listExpand.push(item.id+'.orgchart.'+item.before.pid)"
                      dark
                      color="primary"
                    >{{listExpand.includes(item.id+'.orgchart.'+item.before.pid)? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
                  </v-row>
                  <v-row class="mt-1" v-if="listExpand.includes(item.id+'.orgchart.'+item.before.pid)">
                    <v-card
                      class="user-data-panel"
                      style="margin-top: 0px; width: 100vw;"
                      outlined
                    >
                      <v-treeview
                        open-all
                        dense
                        :items="item.before.moreDetail? item.before.moreDetail:[]"
                      ></v-treeview>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <!-- {{JSON.stringify(this.itemReq)}} -->
        <!-- <pre>{{ JSON.stringify(itemReq.changeDetialList, null, '\t') }}</pre> -->
        <v-card-actions class="justify-center">
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn v-if="statusForApprove === 'pending' && mode ==='approve'" class="mr-0 create-orgchart-header-cancel-btn" color="red accent-2" dark @click="clickReject()">ไม่อนุมัติ</v-btn>
          <v-btn v-if="statusForApprove === 'pending' && mode ==='approve'" class="mr-0 create-orgchart-header-cancel-btn" color="green darken-2" dark @click="clickApprove()">อนุมัติ</v-btn>
          <v-btn v-if="statusForApprove === 'pending' && mode ==='acknowledge'" class="mr-0 create-orgchart-header-cancel-btn" color="green darken-2" dark @click="clickApprove()">รับทราบ</v-btn> -->
          <v-btn elevation="0" class="" color="grey" text @click="closeThisDialog" :disabled="snackbar">ยกเลิก</v-btn>
          <v-btn
            class="button-color-outline head-search-button ml-10 mt-2 mb-2"
            width="180"
            elevation="0"
            outlined
            :disabled="loadingSaveEdit"
            @click="pressConfirmSave('stay')"
          >
          บันทึก และอยู่หน้านี้ต่อ
          </v-btn>
          <v-btn
            class="button-color head-search-button ml-5 mt-2 mb-2 white--text text--lighten-4 font-weight-thin"
            width="310"
            elevation="0"
            :disabled="loadingSaveEdit"
            @click="pressConfirmSave('leave')"
          >
          บันทึก และกลับไปหน้าจัดการโครงสร้างบริษัท
          </v-btn>
        </v-card-actions>
      </v-card>
      <!-- :disabled="reqLists.length==0 && !isZero" -->
      <!-- <DialogTransferPermission/> -->
      <v-snackbar
        v-model="snackbar"
        :timeout="2000"
        top
        centered
        elevation="1"
        color="#ECF8EA"
      >
        <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
        <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
          คุณได้ทำการบันทึกเรียบร้อยแล้ว
        </span>
      </v-snackbar>
    </v-dialog>
</template>

<script>
// import { EventBus } from '@/EventBus'
// import swal from 'sweetalert'
import moment from 'moment'
// import axios from 'axios'
import { insertReqEditOrg, getUserByEmployee } from '@/API/API'
import OverlayLoading from '../../_template/OverlayLoading.vue'

export default {
  props: {
    dialogShow: Boolean,
    itemReq: Object,
    itemApprovers: Array,
    company: String
  },
  components: {
    OverlayLoading
  },
  data () {
    return {
      tab: 0,
      tabName: ['แก้ไขผู้บังคับบัญชา', 'แก้ไขสายบังคับบัญชา'],
      // tabName: ['ผู้บังคับบัญชา', 'สายบังคับบัญชา'],
      sendAllReq: false,
      sendReqDoneList: [],
      reqLists: [],
      listExpand: [],
      snackbar: false,
      loadingSaveEdit: false
    }
  },
  computed: {
    isZero () {
      let result = false
      if (this.itemReq && this.itemReq.changeDetialList && this.itemReq.changeLeaderList) {
        if (this.itemReq.changeDetialList.length === 0 && this.itemReq.changeLeaderList.length === 0) {
          result = true
        } else {
          result = false
        }
      } else {
        result = true
      }
      return result
    }
  },
  mounted () {
  },
  beforeDestroy () {
    // console.log('before des')
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    this.dataSource = []
    this.getSelectLeader()
    // console.log('created')
  },
  methods: {
    async getSelectLeader (value) {
      var temp = []
      var dataobj
      if (value) {
        const payload = {
          companyId: '',
          name: value
        }
        dataobj = payload
      } else {
        const payload = {
          companyId: '',
          name: ''
        }
        dataobj = payload
      }
      const token = this.$store.state.token
      try {
        const res = await getUserByEmployee(dataobj, token)
        if (res.success) {
          if (res.selector.length) {
            res.selector.map((el, index) => {
              temp.push({
                dataShow: el.employeeId + ' - ' + el.titleTh + el.name,
                ...el
              })
            })
            this.itemApprovers = temp
            // console.log('lfdfl==', this.itemLeaders)
          }
        } else {
        }
      } catch (error) {
        this.itemApprovers = []
      } finally {
      }
    },
    async closeThisDialog () {
      this.sendAllReq = false
      this.sendReqDoneList = []
      this.listExpand = []
      this.reqLists = []
      await this.$emit('closeDialogShowDetailOnEdit')
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    initData () {
      // console.log(this.itemReq)
    },
    async regisDataChangeLeader (data) {
      var approveBy = []
      if (data.before.leaderId) approveBy.push({ employeeObjId: data.before.leaderId })
      if (data.after.leaderId) approveBy.push({ employeeObjId: data.after.leaderId })
      this.reqLists.push({
        uid: data.id + '.leader',
        id: data.id,
        type: data.type,
        action: data.action,
        before: data.before,
        after: data.after,
        dataChang: data.dataChang,
        approveBy: approveBy
      })
      // console.log(this.reqLists)
    },
    async unsendDataChangeLeader (data) {
      this.reqLists = this.reqLists.filter(e => {
        return e.uid !== data.id + '.leader'
      })
      // console.log(this.reqLists)
    },
    async regisDataChangeOrgchart (data, subitem) {
      var approveBy = []
      if (data.before.leaderIdPid) {
        approveBy.push({ employeeObjId: data.before.leaderIdPid })
      } else if (!data.before.leaderIdPid && (data.before.leaderIdPicked !== null && data.before.leaderIdPicked !== undefined)) {
        approveBy.push({ employeeObjId: data.before.leaderIdPicked })
      }
      if (data.after.leaderIdPid) {
        approveBy.push({ employeeObjId: data.after.leaderIdPid })
      } else if (!data.after.leaderIdPid && (data.after.leaderIdPicked !== null && data.after.leaderIdPicked !== undefined)) {
        approveBy.push({ employeeObjId: data.after.leaderIdPicked })
      }
      this.reqLists.push({
        uid: data.id + '.orgchart',
        id: data.id,
        type: data.type,
        action: data.action,
        before: data.before,
        after: data.after,
        dataChang: data.dataChang,
        approveBy: approveBy,
        moreDetail: data.moreDetail
      })
      // console.log(this.reqLists)
    },
    async unsendDataChangeOrgchart (data, subitem) {
      this.reqLists = this.reqLists.filter(e => {
        return e.uid !== data.id + '.orgchart'
      })
      // console.log(this.reqLists)
    },
    async pressSendAllReq () {
      this.sendAllReq = true
      this.itemReq.changeLeaderList.forEach(e => {
        this.sendReqDoneList.push(e.id + '.leader')
        // this.regisDataChangeLeader(e)
      })
      this.itemReq.changeDetialList.forEach(e => {
        if (e.before.leaderIdPid || (e.before.leaderIdPicked !== null && e.before.leaderIdPicked !== undefined)) {
          this.sendReqDoneList.push(e.id + '.orgchart')
          // this.regisDataChangeOrgchart(e, 'subitem')
        }
      })
    },
    async pressCancelAllReq () {
      this.sendAllReq = false
      this.sendReqDoneList = []
      this.reqLists = []
    },
    async pressSendReqChangeLeader (item) {
      this.sendReqDoneList.push(item.id + '.leader')
      // this.regisDataChangeLeader(item)
      if (this.reqLists.length === (this.itemReq.changeLeaderList.length + this.itemReq.changeDetialList.length)) {
        this.sendAllReq = true
      } else {
        this.sendAllReq = false
      }
    },
    async cancelpressSendReqChangeLeader (item) {
      this.sendReqDoneList.splice(this.sendReqDoneList.indexOf(item.id + '.leader'), 1)
      // this.unsendDataChangeLeader(item)
      if (this.reqLists.length === (this.itemReq.changeLeaderList.length + this.itemReq.changeDetialList.length)) {
        this.sendAllReq = true
      } else {
        this.sendAllReq = false
      }
    },
    async pressSendReqChangeOrgchart (item, subitem) {
      // console.log(item.id + '.orgchart')
      this.sendReqDoneList.push(item.id + '.orgchart')
      // this.regisDataChangeOrgchart(item, subitem)
      if (this.reqLists.length === (this.itemReq.changeLeaderList.length + this.itemReq.changeDetialList.length)) {
        this.sendAllReq = true
      } else {
        this.sendAllReq = false
      }
    },
    async cancelpressSendReqChangeOrgchart (item, subitem) {
      // console.log(item.id + '.orgchart')
      this.sendReqDoneList.splice(this.sendReqDoneList.indexOf(item.id + '.orgchart'), 1)
      // this.unsendDataChangeOrgchart(item, subitem)
      if (this.reqLists.length === (this.itemReq.changeLeaderList.length + this.itemReq.changeDetialList.length)) {
        this.sendAllReq = true
      } else {
        this.sendAllReq = false
      }
    },
    async settingPayload () {
      this.reqLists = []
      if (this.itemReq && this.itemReq.changeLeaderList) {
        this.itemReq.changeLeaderList.forEach(data => {
          var approveBy = []
          if (this.sendReqDoneList.includes(data.id + '.leader')) {
            if (data.before.leaderId) approveBy.push({ employeeObjId: data.before.leaderId })
            if (data.after.leaderId) approveBy.push({ employeeObjId: data.after.leaderId })
          }
          this.reqLists.push({
            uid: data.id + '.leader',
            id: data.id,
            type: data.type,
            action: data.action,
            before: data.before,
            after: data.after,
            dataChang: data.dataChang,
            approveBy: approveBy
          })
        })
      }
      if (this.itemReq && this.itemReq.changeDetialList) {
        this.itemReq.changeDetialList.forEach(data => {
          var approveBy = []
          if (this.sendReqDoneList.includes(data.id + '.orgchart')) {
            if (data.before.leaderIdPid) {
              approveBy.push({ employeeObjId: data.before.leaderIdPid })
            } else if (!data.before.leaderIdPid && (data.before.leaderIdPicked !== null && data.before.leaderIdPicked !== undefined)) {
              approveBy.push({ employeeObjId: data.before.leaderIdPicked })
            }
            if (data.after.leaderIdPid) {
              approveBy.push({ employeeObjId: data.after.leaderIdPid })
            } else if (!data.after.leaderIdPid && (data.after.leaderIdPicked !== null && data.after.leaderIdPicked !== undefined)) {
              approveBy.push({ employeeObjId: data.after.leaderIdPicked })
            }
          }
          this.reqLists.push({
            uid: data.id + '.orgchart',
            id: data.id,
            type: data.type,
            action: data.action,
            before: data.before,
            after: data.after,
            dataChang: data.dataChang,
            approveBy: approveBy,
            moreDetail: data.moreDetail
          })
        })
      }
    },
    async pressConfirmSave (target) {
      this.loadingSaveEdit = true
      await this.settingPayload()
      var payload = {
        reqEditOrg: this.reqLists,
        reqAddOrg: this.itemReq.addDetialList ? this.itemReq.addDetialList : []
      }
      // console.log('target', target)
      // console.log('payload', payload)
      const token = this.$store.state.token
      try {
        const res = await insertReqEditOrg(payload, token)
        if (res.success) {
          if (res.success) {
            this.snackbar = true
            // console.log('save success')
            setTimeout(() => {
              if (target === 'stay') this.$router.go(0)
              else this.$router.push('/managestructure')
            }, 2000)
          } else {
            console.log('insertReqEditOrg res')
          }
        } else {
          console.log('insertReqEditOrg fail')
        }
      } catch (error) {
        console.log('insertReqEditOrg fail', error)
      } finally {
      }
    }
  }
}
</script>
<style>

.v-treeview--dense .v-treeview-node__root {
    min-height: 30px;
    font-size: 13px;
    font-family: 'Sarabun', sans-serif !important;
}
.loading-waitingSaveEdit {
  position: absolute;
  z-index: 1;
}
</style>
